import axios, { AxiosResponse } from 'axios';
import { useQuery } from 'react-query';

import { APP_CONFIG } from 'api/use-query-constants';
import ReactQueryHook from 'utils/react-query-hook';
import { AppConfig } from './config.model';

export interface IUseConfigQuery {
    isLoading: boolean;
    error?: unknown;
    data?: AppConfig;
}

const useConfig = (): ReactQueryHook<AppConfig> => {
    const { isLoading, error, data }: IUseConfigQuery = useQuery(APP_CONFIG, () =>
        axios
            .get(`${process.env.PUBLIC_URL}/config.json`)
            .then((response: AxiosResponse<AppConfig>) => {
                return response?.data;
            })
            .catch((e: Error) => {
                throw e;
            }),
    );

    return new ReactQueryHook<AppConfig>(isLoading, error, data);
};

export default useConfig;
